import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CellType, IgxGridCell} from '@infragistics/igniteui-angular/grids/core';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxDividerDirective, IgxDividerModule } from '@infragistics/igniteui-angular/directives';
import {INeodataGridCell, INeodataMenu} from '../../../../core/models/interfaces/generico-interface';
import {TranslateModule} from '@ngx-translate/core';
import {NgClass, NgStyle} from '@angular/common';

@Component({
  selector: 'app-context-menu-generico',
  templateUrl: './context-menu-generico.component.html',
  styleUrls: ['./context-menu-generico.component.scss'],
  imports: [
    IgxIconComponent,
    NgClass,
    NgStyle,
    IgxDividerModule,
    IgxDividerDirective,
    TranslateModule
  ]
})
export class ContextMenuGenericoComponent implements OnInit {
  @Input()
  public x = 0;

  @Input()
  public y = 0;

  @Input()
  public size: string;

  @Input()
  public cellMenuContextual: IgxGridCell | CellType;

  @Input()
  public menusOpciones: INeodataMenu[] = [];

  @Input()
  public subMenusOpciones: INeodataMenu[] = [];

  @Input()
  public lengthMenu: number;

  @Output()
  public accionSeleccionada = new EventEmitter<INeodataGridCell>();

  public subX = 0;
  public subY = 0;

  constructor() {
  }

  ngOnInit(): void {
  }

  public copySelectedCellData(accion: INeodataMenu) {
    this.accionSeleccionada.emit({accionMenu: accion, dataSelected: this.cellMenuContextual});
  }

  public over(evt: any, menu: INeodataMenu) {
    this.subMenusOpciones = menu.subMenu;
    const menuFiltered = this.menusOpciones.filter(x => !x.disabled);
    const idx = menuFiltered.reverse().findIndex(x => x.id === menu.id);
    const clickPosition = this.x + 285;
    this.subX = document.body.clientWidth - (clickPosition) < (285) ?
      clickPosition - (285 * 2)
      : clickPosition;
    const subYNormal = this.y + (this.lengthMenu * 37) - (idx + 1) * 37;
    this.subY = document.body.clientHeight - subYNormal < (this.subMenusOpciones?.length * 37) ?
      subYNormal - ((this.subMenusOpciones?.length - 1) * 37)
      : subYNormal;
  }
}
